@if (is_game_active()){

  <div class="layout-container">

    <header class="board-header">

      <button class="icon-button" (click)="exitBoard()" title="Exit Game">
        <img src="assets/arrow_back.svg" alt="Back" />
      </button>

      <div class="points-badge">
        <span class="points-label">PTS</span>
        <span class="points-value">{{points()}}</span>
      </div>

    </header>

    <main class="board-main">

      <div class="timer-display" [class.disabled]="round_status().pending">
        <span class="timer-label">TIME</span>
        <span class="timer-value">{{rounded_time()}}</span>
      </div>

      <div class="controls-area">
        
        @if (round_status().ready){
          
          <div class="action-group">

            <button class="action-button primary large" (click)="startRound(false)">START ROUND</button>

            @if (!are_doubles_available()){
              <p class="status-message muted">No doubles available</p>
            }
            @else if (!are_doubles_allowed()){
              <p class="status-message muted">Reach 2 points to use doubles</p>
            }
            @else{
              <button class="action-button secondary" (click)="startRound(true)">START DOUBLE ROUND</button>
            }

          </div>

        }

        @else if (round_status().active){
          
          <button class="action-button primary large" (click)="endRound()">END ROUND</button>

        }

        @else if (round_status().pending){
          
          <div class="action-grid">

            <button class="action-button success" (click)="guessWord()">GUESSED</button>
            <button class="action-button destructive" (click)="missWord()">MISSED</button>
            
            @if (are_passes_available()){
              <div class="full-width">
                 <button class="action-button outline" (click)="passWord()">PASS</button>
              </div>
            }
            
            @else{
              <div class="full-width">
                <button class="action-button outline" disabled>NO PASSES</button>
              </div>
            }

          </div>

        }

      </div>

    </main>

  </div>

}

@else{

  <app-end-game
    [points]="points()"
    [passes]="passes()"
    [doubles]="doubles()"
  />

}
